import React, { useState, useEffect } from "react";

function AssetsLiabilitiesStep({
  data = { assets: [], liabilities: [] },
  updateCrmData,
}) {
  const [assets, setAssets] = useState(data.assets || []);
  const [liabilities, setLiabilities] = useState(data.liabilities || []);

  useEffect(() => {
    updateCrmData({ assetsLiabilities: { assets, liabilities } });
  }, [assets, liabilities, updateCrmData]);

  // ===== ASSETS =====
  const addAsset = () => {
    setAssets([...assets, { type: "", value: "" }]);
  };

  const updateAsset = (index, field, value) => {
    const updated = [...assets];
    updated[index][field] = value;
    setAssets(updated);
  };

  const removeAsset = (index) => {
    setAssets(assets.filter((_, i) => i !== index));
  };

  // ===== LIABILITIES =====
  const addLiability = () => {
    setLiabilities([
      ...liabilities,
      { type: "", limit: "", balance: "", repayment: "" },
    ]);
  };

  const updateLiability = (index, field, value) => {
    const updated = [...liabilities];
    updated[index][field] = value;
    setLiabilities(updated);
  };

  const removeLiability = (index) => {
    setLiabilities(liabilities.filter((_, i) => i !== index));
  };

  // Totals
  const totalAssets = assets.reduce(
    (sum, a) => sum + (parseFloat(a.value) || 0),
    0
  );
  const totalLiabilities = liabilities.reduce(
    (sum, l) => sum + (parseFloat(l.balance) || 0),
    0
  );

  return (
    <div>
      <h2>Assets & Liabilities</h2>

      {/* Totals Summary */}
      <div style={{ display: "flex", gap: "2rem", marginBottom: "1rem" }}>
        <div>
          <strong>Total Assets</strong>
          <br />${totalAssets.toLocaleString()}
        </div>
        <div>
          <strong>Total Liabilities</strong>
          <br />${totalLiabilities.toLocaleString()}
        </div>
      </div>

      {/* ===== ASSETS SECTION ===== */}
      <h3>Assets</h3>
      {assets.map((asset, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap: "10px",
            marginBottom: "10px",
            alignItems: "center",
          }}
        >
          <select
            value={asset.type}
            onChange={(e) => updateAsset(index, "type", e.target.value)}
          >
            <option value="">Select Asset</option>
            <option value="Savings">Savings</option>
            <option value="Property">Property</option>
            <option value="Shares">Shares</option>
            <option value="Superannuation">Superannuation</option>
            <option value="Other">Other</option>
          </select>

          <input
            type="number"
            placeholder="Value $"
            value={asset.value}
            onChange={(e) => updateAsset(index, "value", e.target.value)}
          />

          <button onClick={() => removeAsset(index)} style={{ color: "red" }}>
            ❌
          </button>
        </div>
      ))}
      <button
        onClick={addAsset}
        style={{ background: "#4EDCF6", padding: "6px 12px" }}
      >
        + Add Asset
      </button>

      <br />
      <br />

      {/* ===== LIABILITIES SECTION ===== */}
      <h3>Liabilities</h3>
      {liabilities.map((liability, index) => (
        <div
          key={index}
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr 1fr auto",
            gap: "10px",
            marginBottom: "10px",
            alignItems: "center",
          }}
        >
          <select
            value={liability.type}
            onChange={(e) =>
              updateLiability(index, "type", e.target.value)
            }
          >
            <option value="">Select Liability</option>
            <option value="Credit Card">Credit Card</option>
            <option value="Personal Loan">Personal Loan</option>
            <option value="Car Loan">Car Loan</option>
            <option value="Home Loan">Home Loan</option>
            <option value="HECS/HELP">HECS/HELP</option>
            <option value="Other">Other</option>
          </select>

          <input
            type="number"
            placeholder="Limit $"
            value={liability.limit}
            onChange={(e) =>
              updateLiability(index, "limit", e.target.value)
            }
          />

          <input
            type="number"
            placeholder="Balance $"
            value={liability.balance}
            onChange={(e) =>
              updateLiability(index, "balance", e.target.value)
            }
          />

          <input
            type="number"
            placeholder="Repayment $"
            value={liability.repayment}
            onChange={(e) =>
              updateLiability(index, "repayment", e.target.value)
            }
          />

          <button
            onClick={() => removeLiability(index)}
            style={{ color: "red" }}
          >
            ❌
          </button>
        </div>
      ))}
      <button
        onClick={addLiability}
        style={{ background: "#4EDCF6", padding: "6px 12px" }}
      >
        + Add Liability
      </button>
    </div>
  );
}

export default AssetsLiabilitiesStep;
